import React from "react";
import styles from "./styles.module.css";
import clsx from "clsx";
import CardComponent from "../CardComponent";
import Accordion from "../Accordion";
import AccordionItem from "../Accordion/AccordionItem";
import { useTranslation } from "react-i18next";
import { ReactComponent as FileIcon } from "../../assets/plain-files-icon.svg";
import { WidgetItem } from "../../interfaces/TournamentsConfig";

interface GameRulesCardProps {
  tournament: WidgetItem;
}

const GameRulesCard: React.FC<GameRulesCardProps> = ({ tournament }) => {
  const { t } = useTranslation();
  const { pointers } = tournament || {};
  const mappedItems = pointers?.items || [];

  return (
    <>
      <CardComponent
        className={clsx(styles.gameRulesCard, styles.cardWithHeading)}
        borderType="Md"
      >
        <Accordion>
          <AccordionItem
            title={
              <div className={clsx(styles.accordionCardHeading)}>
                <FileIcon /> {t("gameRules")}
              </div>
            }
            isPaddingDisable="noPadding"
            accordionInnerContentClassName={clsx(styles.accordionInnerContent)}
          >
            <Accordion>
              {mappedItems.map((item, index) => (
                <AccordionItem
                  key={item.id || index}
                  title={
                    <div
                      className={clsx(
                        styles.innerAccordionTitle,
                        "fontSizeSm14 fontWeightMedium"
                      )}
                    >
                      {item.text}
                      {item.tag?.enable && (
                        <span
                          className={clsx(
                            styles.importantTag,
                            "fontWeightBold textUppercase"
                          )}
                        >
                          {item.tag.text}
                        </span>
                      )}
                    </div>
                  }
                  accordionHeaderClassName={clsx(styles.innerAccordionHeader)}
                  iconType="plus"
                  isPaddingDisable="noPadding"
                  accordionItemClassName={clsx(styles.nestedAccordionItem)}
                  accordionInnerContentClassName={clsx(
                    styles.accordionNestedInnerContent
                  )}
                  isExpanded={item.defaultExpanded}
                >
                  {item?.description && <div>{item?.description} <br/><br/></div>}
                  <ul>
                    {item?.expandedItems?.map((expandedItem, idx) => (
                      <li
                        key={idx}
                        className={clsx(styles.expandedContent, "fontSizeSm12")}
                      >
                        <div
                          dangerouslySetInnerHTML={{
                            __html: expandedItem.text,
                          }}
                        />
                        {expandedItem.infoText && (
                          <p
                            className={clsx(styles.infoText)}
                            dangerouslySetInnerHTML={{
                              __html: expandedItem.infoText,
                            }}
                          />
                        )}
                      </li>
                    ))}
                  </ul>
                </AccordionItem>
              ))}
            </Accordion>
          </AccordionItem>
        </Accordion>
      </CardComponent>
    </>
  );
};

export default GameRulesCard;
